export default __webpack_public_path__ + "static/media/mint_now_button.dea7549f.png";